import { initialState } from '../../components/Router/reducer';

export const deepLinks = () => {
  // Reset any state stored in the history API
  if (history && history.state) {
    history.replaceState(initialState, 'Edit');
  }
};
